import * as zoneTypeKeys from "../../model/lighting-zone-types/zoneTypeKeys.js";

export const formatSceneTestSceneValue = (zone, sceneLevel) => {
  switch (zone.zoneType) {
    case zoneTypeKeys.IO:
      return sceneLevel;
    case zoneTypeKeys.CBUS:
      return `${sceneLevel}%`;
    default:
      return sceneLevel;
  }
};

export const formatZoneListSceneValue = (type, sceneLevel) => {
  switch (type) {
    case zoneTypeKeys.IO:
      return sceneLevel;
    case zoneTypeKeys.CBUS:
      return sceneLevel !== null ? `${sceneLevel}%` : "No Scene Value";
    default:
      return sceneLevel;
  }
};

export const formatZoneListReviewSceneValue = (type, levelPercentage) => {
  switch (type) {
    case zoneTypeKeys.IO:
      return levelPercentage.isOn === true ? "On" : "Off";
    case zoneTypeKeys.CBUS:
      return `${levelPercentage.levelPercentage}%`;
    default:
      return levelPercentage.levelPercentage;
  }
};
